<div class="layout-topbar">
  <div class="layout-topbar-wrapper">
    <div class="layout-topbar-left">
      <div class="layout-topbar-logo-wrapper">
        <!--<a href="#" class="layout-topbar-logo">
          <img src="assets/images/insep_logo_blanc.png" alt="INSEP" />
          <span class="app-name">SUIVI</span>
        </a>-->
      </div>

      <a href="#" class="sidebar-menu-button" (click)="app.onMenuButtonClick($event)">
        <i class="pi pi-bars"></i>
      </a>

      <!--<a href="#" class="megamenu-mobile-button" (click)="app.onMegaMenuMobileButtonClick($event)">
        <i class="pi pi-align-right megamenu-icon"></i>
      </a>-->

      <a href="#" class="topbar-menu-mobile-button" (click)="app.onTopbarMobileMenuButtonClick($event)">
        <i class="pi pi-ellipsis-v"></i>
      </a>
    </div>
    <div class="layout-topbar-right fadeInDown">
      <ul class="layout-topbar-actions">
        <li #profile class="topbar-item profile-item" [ngClass]="{ 'active-topmenuitem': app.activeTopbarItem === profile }">
          <a href="#" (click)="app.onTopbarItemClick($event, profile)">
            <span class="profile-image-wrapper div-rounded-photourl" *ngIf="photo" [style.background-image]="'url(\'' + photo + '\')'"></span>
            <span class="profile-info-wrapper">
              <h3>{{ nom }}</h3>
              <!--<span>Design</span>-->
            </span>
          </a>
          <ul class="profile-item-submenu fadeInDown">
            <li class="profile-submenu-header">
              <div class="performance">
                <img src="assets/layout/images/topbar/asset-bars.svg" alt="mirage-layout" />
              </div>
              <div class="profile">
                <span class="profile-image-wrapper div-rounded-photourl" *ngIf="photo" [style.background-image]="'url(\'' + photo + '\')'"></span>
                <h1>{{ nom }}</h1>
                <!--<span>Design</span>-->
              </div>
            </li>
            <li class="layout-submenu-footer">
              <button class="signout-button" (click)="logout()">Déconnexion</button>
              <div class="night-switch" [ngClass]="{ 'layout-dark': settingsService.SiteIsDark, 'layout-light': !settingsService.SiteIsDark }">
                <button class="dark-switch" (click)="changeLayout($event, true)"><i class="fa fa-circle" aria-hidden="true"></i></button>
                <button class="light-switch" (click)="changeLayout($event, false)"><i class="fa fa-circle" aria-hidden="true"></i></button>
              </div>
            </li>
          </ul>
        </li>
        <!--<li>
          <a href="#" class="layout-rightpanel-button" (click)="app.onRightPanelButtonClick($event)">
            <i class="pi pi-arrow-left"></i>
          </a>
        </li>-->
      </ul>

      <ul class="profile-mobile-wrapper">
        <li #mobileProfile class="topbar-item profile-item" [ngClass]="{ 'active-topmenuitem': app.activeTopbarItem === mobileProfile }">
          <a href="#" (click)="app.onTopbarItemClick($event, mobileProfile)">
            <span class="profile-image-wrapper div-rounded-photourl" *ngIf="photo" [style.background-image]="'url(\'' + photo + '\')'"></span>
            <span class="profile-info-wrapper">
              <h3>{{ nom }}</h3>
              <!--<span>Design</span>-->
            </span>
          </a>
          <ul class="fadeInDown">
            <li class="layout-submenu-footer">
              <button class="signout-button" (click)="logout()">Déconnexion</button>
              <div class="night-switch" [ngClass]="{ 'layout-dark': settingsService.SiteIsDark, 'layout-light': !settingsService.SiteIsDark }">
                <button class="dark-switch" (click)="changeLayout($event, true)"><i class="fa fa-circle" aria-hidden="true"></i></button>
                <button class="light-switch" (click)="changeLayout($event, false)"><i class="fa fa-circle" aria-hidden="true"></i></button>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</div>
